import { React } from '../lib';
export const Signal = (props) => {
    const [signal, setSignal] = React.useState(0);
    const updateSignal = () => {
        setSignal(signal + 1);
    };
    return React.createElement(React.Fragment, null, props.children(updateSignal));
};
//# sourceMappingURL=signal.js.map